<template>
  <div class="h-100 w-100">
    <div v-bind:class="isTab ? 'h-100' :'card h-100'">
      <div v-bind:class="isTab ? 'd-flex' : 'card-header d-flex'" v-if="!show.form.slot">
        <h4 class="card-title-datatable">
          <span @click="$emit('forceupdate')" style="cursor: pointer">
            {{ names }}</span
          >
        </h4>
        <button
          class="btn btn-primary mx-1"
          @click="$emit(b.action, b)"
          :title="b.title"
          v-for="(b, i) in btns"
          :key="i"
        >
          <i :class="'menu-icon tf-icons bx m-0 bx-' + b.icon"></i> {{ b.name }}
        </button>
        <button
          class="btn btn-primary mx-1"
          @click="openFilter"
          title="Filtros"
          v-if="btnfilter == null || btnfilter == true"
        >
          <i class="menu-icon tf-icons bx bx-filter-alt m-0"></i>
        </button>
        <button
          class="btn btn-primary"
          @click="create"
          v-if="cancreate == null || cancreate"
          title="Criar novo"
        >
          {{ button }}
        </button>
      </div>
      <div class="card-header d-flex" v-else>
        <h4 class="card-title-datatable">
          <button class="form-back-button" @click="closeForm">
            <i class="menu-icon tf-icons bx bx-left-arrow-alt m-0"></i>
          </button>
          {{ name }}
        </h4>

        <button
          class="btn btn-primary mx-1"
          @click="$emit(b.action, b)"
          :title="b.title"
          v-for="(b, i) in btnsaction"
          v-show="
            (editId && (b.edit == null || b.edit)) ||
            (!editId && (b.create == null || b.create))
          "
          :key="i"
        >
          <i :class="'menu-icon tf-icons bx m-0 bx-' + b.icon"></i> {{ b.name }}
        </button>
        <button
          type="button"
          class="btn btn-primary"
          v-if="editId"
          @click="doUpdate"
        >
          <i class="menu-icon tf-icons bx m-0 bx-save"></i>
          Salvar
        </button>
        <button type="button" class="btn btn-primary" v-else @click="doCreate">
          <i class="menu-icon tf-icons bx m-0 bx-save"></i>
          Criar
        </button>
      </div>
      <div class="card-body form-body">
        <div class="form-body" v-if="show.form.slot">
          <slot name="form" :crud="this"></slot>
        </div>
        <div class="h-100" v-if="show.list">
          <slot name="list" :crud="this"></slot>
        </div>
      </div>
    </div>
    <div class="modal fade" ref="modal_form" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" :class="{ 'max-width-100vh': bigModal }" role="document">
        <div class="modal-content" >
          <div class="modal-header bg-primary pb-3">
            <h5 class="modal-title text-white">
              {{ editId ? "Editar" : "Criar" }} {{ name }}
            </h5>
            <button type="button" class="btn-close" @click="closeForm"></button>
          </div>
          <div class="modal-body form-modal-body">
            <slot name="form" :crud="this" v-if="show.form.modal"></slot>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              v-if="editId"
              @click="doUpdate"
            >
              Salvar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              v-else
              @click="doCreate"
              :disabled="load"
            >
              <div
                class="spinner-border spinner-border-sm text-white"
                role="status"
                v-if="load"
              >
                <span class="visually-hidden">Loading...</span>
              </div>
              {{ load ? "Criando..." : "Criar" }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" ref="modal_filter" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" :class="{ 'max-width-100vh': bigModal }" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary pb-3">
            <h5 class="modal-title text-white">Filtrar {{ names }}</h5>
            <button
              type="button"
              class="btn-close"
              @click="closeFilter"
            ></button>
          </div>
          <div class="modal-body form-modal-body">
            <slot
              name="filter"
              :crud="this"
              :filters="filters"
              v-if="show.filter"
            ></slot>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click="filters = {}"
            >
              Limpar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="$emit('filter', filters)"
            >
              Aplicar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" tabindex="-1" ref="modal_delete">
      <div class="modal-dialog modal-dialog-centered" :class="{ 'max-width-100vh': bigModal }" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white mb-2">Deletar registro</h5>
            <button
              type="button"
              class="btn-close"
              @click="deleteId = null"
            ></button>
          </div>
          <div class="modal-body">
            <span v-if="deleteItemName && deleteConfirmText">
              {{ deleteConfirmText.replace('{name}', deleteItemName) }}
            </span>
            <span v-else-if="deleteItemName && deleteItemLabel">
              Deseja realmente deletar {{ deleteItemLabel }} "<strong>{{ deleteItemName }}</strong>"?
            </span>
            <span v-else-if="deleteItemName">
              Deseja realmente deletar o registro "<strong>{{ deleteItemName }}</strong>"?
            </span>
            <span v-else>
              Deseja realmente deletar o registro {{ deleteId }}?
            </span>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger"
              @click="doDelete(deleteId)"
            >
              Deletar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Edição pendente num componente do form (ex.: pin do mapa em edição) ao clicar
         em Salvar/Criar: pergunta o que fazer em vez de descartar em silêncio. -->
    <div v-if="pendingPrompt" class="crud-pending-backdrop" @click.self="resolvePending('back')">
      <div class="crud-pending-dialog">
        <h5 class="mb-2">Alterações não salvas</h5>
        <p class="mb-3">{{ pendingPrompt.guard.message || "Há uma edição em andamento que ainda não foi aplicada." }}</p>
        <div class="crud-pending-actions">
          <button type="button" class="btn btn-outline-secondary" @click="resolvePending('back')">
            Voltar
          </button>
          <button type="button" class="btn btn-outline-danger" @click="resolvePending('discard')">
            Descartar
          </button>
          <button type="button" class="btn btn-primary" @click="resolvePending('save')">
            Salvar alterações
          </button>
        </div>
      </div>
    </div>
    <Alert ref="alert"></Alert>
  </div>
</template>
<script>
import Alert from "../Alert.vue";
export default {
  props: [
    "modal",
    "bigModal",
    "name",
    "names",
    "url",
    "cancreate",
    "btns",
    "button",
    "btnfilter",
    "btnsaction",
    "closeonedit",
    "closeoncreate",
    "isTab",
    "deleteConfirmText",
    "deleteItemLabel",
    "useIdInUrl"
  ],
  components: {
    Alert,
  },
  data() {
    return {
      show: {
        form: {
          modal: false,
          slot: false,
          bigModal: false,
        },
        filter: false,
        list: true,
      },
      filters: {},
      editId: null,
      form: {},
      deleteId: null,
      deleteItemName: null,
      error: null,
      load: false,
      // Componentes do form com edição própria (ex.: Local.vue) se registram aqui.
      // Cada guarda: { hasPending(), save(), discard(), message }.
      pendingGuards: [],
      pendingPrompt: null, // { action: 'create' | 'update', guard }
    };
  },
  provide() {
    return {
      crudPendingGuard: {
        register: (guard) => this.pendingGuards.push(guard),
        unregister: (guard) => {
          this.pendingGuards = this.pendingGuards.filter((g) => g !== guard);
        },
      },
    };
  },
  methods: {
    // true = havia edição pendente e a confirmação foi aberta (o envio fica para depois).
    askPending(action) {
      const guard = this.pendingGuards.find((g) => g.hasPending());
      if (!guard) return false;
      this.pendingPrompt = { action, guard };
      return true;
    },
    resolvePending(choice) {
      const { action, guard } = this.pendingPrompt;
      this.pendingPrompt = null;
      if (choice === "back") return;
      if (choice === "save") guard.save();
      else guard.discard();
      // save() atualiza o form via evento; espera o Vue aplicar antes de enviar.
      this.$nextTick(() => {
        if (action === "update") this.runUpdate();
        else this.runCreate();
      });
    },
    doCreate() {
      if (this.askPending("create")) return;
      this.runCreate();
    },
    doUpdate() {
      if (this.askPending("update")) return;
      this.runUpdate();
    },
    openFilter() {
      this.show.filter = true;
      $(this.$refs.modal_filter).modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    closeFilter() {
      $(this.$refs.modal_filter).modal("hide");
      setTimeout(() => {
        this.show.filter = false;
      }, 500);
    },
    openForm() {
      if (this.modal) {
        $(this.$refs.modal_form).modal({
          backdrop: "static",
          keyboard: false,
        });
        $(this.$refs.modal_form).appendTo("body");
        this.show.form.modal = true;
      } else {
        this.show.list = false;
        this.show.form.slot = true;
      }
    },
    closeForm() {
      if (this.modal) {
        $(this.$refs.modal_form).modal("hide");
        setTimeout(() => {
          this.show.form.modal = false;
        }, 500);
      } else {
        this.show.list = true;
        this.show.form.slot = false;
      }
    },
    afterSave() {
      this.closeForm();
      this.$emit('forceRerender');
    },
    create() {
      this.error = null;
      this.form = {};
      this.editId = null;
      this.$emit("onformcreate", this.form);
      this.openForm();
    },
    edit(data) {
      var newData = Object.assign({}, data);

      this.error = null;
      this.form = {};
      this.editId = newData.id;
      this.form = newData;
      this.$emit("onformedit", this.form);
      this.openForm();
    },
    delete(item) {
      if (typeof item === 'object' && item !== null) {
        this.deleteId = item.id;
        
        this.deleteItemName = item.nome || item.name || item.Name || item.descricao || item.description;
      } else {
        this.deleteId = item;
        this.deleteItemName = null;
      }
    },
    doDelete(id) {
      const currentId = this.deleteId;
      this.deleteId = null;
      this.deleteItemName = null;
      
      this.load = true;
      this.$emit("ondelete", currentId);
      this.crudDelete(this.url, currentId)
        .then((res) => {
          this.$refs.alert.show(
            "Deletado",
            "O registro deletado com sucesso!",
            null,
            5000,
            "bg-primary"
          );
          this.$emit("delete", currentId);
        })
        .catch((e) => {
          this.$refs.alert.show(
            "Erro",
            "Não foi possível deletar o registro!",
            null,
            5000,
            "bg-danger"
          );
        })
        .finally(() => {
          this.load = false;
          
          setTimeout(() => {
            $(this.$refs.modal_delete).appendTo(this.$el);
          }, 500);
        });
    },
    runCreate() {
      this.load = true;
      this.error = null;
      
      try {
        this.$emit("oncreate", this.form);

        this.crudCreate(this.url, this.form)
          .then((res) => {
            this.$refs.alert.show(
              "Criado",
              "O registro foi criado com sucesso!",
              null,
              5000,
              "bg-primary"
            );

            if (this.closeoncreate == null || this.closeoncreate) {
              this.closeForm();
            } else {
              this.edit(res.data);
            }
          })
          .catch((e) => {
            if (e.response && e.response.status == 400) {
              this.error = e.response.data;
              this.$refs.alert.show(
                "Erro",
                "Alguns campos possuem erros!",
                null,
                3000,
                "bg-danger"
              );
            } else {
              this.$refs.alert.show(
                "Erro",
                "Não foi possível criar o registro!",
                null,
                5000,
                "bg-danger"
              );
            }
          })
          .finally(() => {
            this.load = false;
            this.$emit("forceRerender");
          });
      } catch (error) {
        console.error("Erro durante a preparação dos dados:", error);
        this.load = false;
      }
    },
    runUpdate() {
  this.load = true;
  this.error = null;
  
  try {
    this.$emit("onupdate", this.form);
    
    if (!this.form.id) {
      throw new Error("ID não encontrado para atualização");
    }
    const updateUrl = this.useIdInUrl ? `${this.url}/${this.form.id}` : this.url;
    this.urlPut(updateUrl, this.form)
      .then((res) => {
        this.$refs.alert.show(
          "Atualizado",
          "O registro foi atualizado com sucesso!",
          null,
          5000,
          "bg-primary"
        );
        
        if (this.url == "/AdminUser/User") {
          this.updateUser();
        }
        
        if (this.closeonedit == null || this.closeonedit) {
          this.closeForm();
        }
        
        this.$emit("forceRerender");
      })
      .catch((e) => {
        console.error("Erro na atualização:", e);
        console.error("Response error:", e.response);
        
        if (e.response && e.response.status == 400) {
          this.error = e.response.data;
          this.$refs.alert.show(
            "Erro",
            "Alguns campos possuem erros!",
            null,
            3000,
            "bg-danger"
          );
        } else {
          this.$refs.alert.show(
            "Erro",
            "Não foi possível atualizar o registro!",
            null,
            5000,
            "bg-danger"
          );
        }
      })
      .finally(() => {
        this.load = false;
      });
  } catch (error) {
    console.error("Erro durante a preparação dos dados:", error);
    this.load = false;
    // Só mostrar alert se houver mensagem de erro
    if (error.message) {
      this.$refs.alert.show(
        "Erro",
        error.message,
        null,
        3000,
        "bg-danger"
      );
    }
  }
},
  },
  mounted() {},
  watch: {
    deleteId(id) {
      if (id != null) {
        $(this.$refs.modal_delete).appendTo("body");
        $(this.$refs.modal_delete).css('z-index', '1051');
        $(this.$refs.modal_delete).modal({
          backdrop: "static",
          keyboard: false,
          show: true
        });
      } else {
        $(this.$refs.modal_delete).modal("hide");
        
        setTimeout(() => {
          $(this.$refs.modal_delete).appendTo(this.$el);
        }, 500);
      }
    },
  },
};
</script>

<style>
.crud-pending-backdrop {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
.crud-pending-dialog {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  padding: 20px;
  width: 100%;
  max-width: 440px;
}
.crud-pending-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}
.form-body {
  min-height: calc(100% - 96px);
}
.reload-icon {
  line-height: 25px;
  cursor: pointer;
}
.form-modal-body {
  max-height: calc(100vh - 200px);
  overflow: auto;
}
.form-body {
  height: calc(100% - 20px);
  max-height: calc(100% - 20px);
  overflow: auto;
  padding-left: 15px;
  padding-right: 15px;
}
.form-back-button {
  background-color: transparent;
  outline: none;
  border: none;
}
.form-back-button i {
  font-size: 30px;
}
.max-width-100vh {
  max-width: 100vh;
}

.modal-backdrop {
  z-index: 1050 !important;
}

.modal {
  z-index: 1051 !important;
}

body .modal-open .modal {
  display: flex !important;
  align-items: center;
  justify-content: center;
}

@media only screen and (max-width: 821px) {
  .btn{
    font-size: 20px;
  }
}
</style>
